import { render } from "./ceshi.vue?vue&type=template&id=0506c4fc"
import script from "./ceshi.vue?vue&type=script&lang=js"
export * from "./ceshi.vue?vue&type=script&lang=js"

import "./ceshi.vue?vue&type=style&index=0&id=0506c4fc&lang=css"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__